// This file is auto-generated by @hey-api/openapi-ts
export var AdminTransferType;
(function (AdminTransferType) {
    AdminTransferType["CREDIT"] = "credit";
    AdminTransferType["DEBIT"] = "debit";
})(AdminTransferType || (AdminTransferType = {}));
/**
 * Approval state for a reviewable object:
 * * `pending`: approval is required and has not yet been resolved.
 * * `completed`: approval was required and has been resolved.
 * * `not_required`: this object never required approval.
 */
export var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus["PENDING"] = "pending";
    ApprovalStatus["COMPLETED"] = "completed";
    ApprovalStatus["NOT_REQUIRED"] = "not_required";
})(ApprovalStatus || (ApprovalStatus = {}));
/**
 * Authentication factor type
 */
export var AuthFactorType;
(function (AuthFactorType) {
    AuthFactorType["SMS"] = "sms";
    AuthFactorType["TOTP"] = "totp";
    AuthFactorType["WEBAUTHN"] = "webauthn";
})(AuthFactorType || (AuthFactorType = {}));
/**
 * The account condition that should have caused the authorization to be declined.
 */
export var CardDisputeAccountStatus;
(function (CardDisputeAccountStatus) {
    CardDisputeAccountStatus["ACCOUNT_CLOSED"] = "account_closed";
    CardDisputeAccountStatus["CREDIT_PROBLEM"] = "credit_problem";
    CardDisputeAccountStatus["FRAUD"] = "fraud";
})(CardDisputeAccountStatus || (CardDisputeAccountStatus = {}));
export var CardDisputeEligibilityReason;
(function (CardDisputeEligibilityReason) {
    CardDisputeEligibilityReason["TRANSACTION_NOT_FOUND"] = "transaction_not_found";
    CardDisputeEligibilityReason["TRANSACTION_NOT_SETTLED"] = "transaction_not_settled";
    CardDisputeEligibilityReason["CURRENCY_MISMATCH"] = "currency_mismatch";
    CardDisputeEligibilityReason["AMOUNT_EXCEEDS_SETTLED_AMOUNT"] = "amount_exceeds_settled_amount";
    CardDisputeEligibilityReason["AMOUNT_EXCEEDS_RECEIPT_DIFFERENCE"] = "amount_exceeds_receipt_difference";
    CardDisputeEligibilityReason["ACTIVE_DISPUTE_EXISTS"] = "active_dispute_exists";
    CardDisputeEligibilityReason["EXCEEDED_FILING_WINDOW"] = "exceeded_filing_window";
    CardDisputeEligibilityReason["MISSING_REQUIRED_EVIDENCE"] = "missing_required_evidence";
})(CardDisputeEligibilityReason || (CardDisputeEligibilityReason = {}));
/**
 * Network-agnostic classification for dispute document evidence.
 */
export var CardDisputeEvidenceType;
(function (CardDisputeEvidenceType) {
    CardDisputeEvidenceType["CARDHOLDER_LETTER"] = "cardholder_letter";
    CardDisputeEvidenceType["MERCHANT_LETTER"] = "merchant_letter";
    CardDisputeEvidenceType["SALES_DRAFT"] = "sales_draft";
    CardDisputeEvidenceType["TE_FOLIO"] = "te_folio";
    CardDisputeEvidenceType["CREDIT_VOUCHER"] = "credit_voucher";
    CardDisputeEvidenceType["SHIPPING_RECEIPT"] = "shipping_receipt";
    CardDisputeEvidenceType["PROOF_OF_DELIVERY"] = "proof_of_delivery";
    CardDisputeEvidenceType["BANK_STATEMENT"] = "bank_statement";
    CardDisputeEvidenceType["CANCELLED_CHECK"] = "cancelled_check";
    CardDisputeEvidenceType["SECOND_OPINION"] = "second_opinion";
    CardDisputeEvidenceType["FULFILLMENT"] = "fulfillment";
    CardDisputeEvidenceType["AUTHORIZATION_RECORD"] = "authorization_record";
    CardDisputeEvidenceType["NETWORK_DOCUMENT"] = "network_document";
    CardDisputeEvidenceType["UPDATED_CARDHOLDER_LETTER"] = "updated_cardholder_letter";
    CardDisputeEvidenceType["UPDATED_MERCHANT_LETTER"] = "updated_merchant_letter";
    CardDisputeEvidenceType["AFFIDAVIT_OF_FRAUD"] = "affidavit_of_fraud";
    CardDisputeEvidenceType["OTHER"] = "other";
    CardDisputeEvidenceType["NETWORK_EXHIBIT"] = "network_exhibit";
    CardDisputeEvidenceType["ISSUER_CERTIFICATION"] = "issuer_certification";
    CardDisputeEvidenceType["TRANSACTION_RECEIPT"] = "transaction_receipt";
})(CardDisputeEvidenceType || (CardDisputeEvidenceType = {}));
/**
 * Whether a dispute concerns merchandise or services.
 */
export var CardDisputeMerchandiseOrServices;
(function (CardDisputeMerchandiseOrServices) {
    CardDisputeMerchandiseOrServices["MERCHANDISE"] = "merchandise";
    CardDisputeMerchandiseOrServices["SERVICES"] = "services";
})(CardDisputeMerchandiseOrServices || (CardDisputeMerchandiseOrServices = {}));
export var CardDisputeNextAction;
(function (CardDisputeNextAction) {
    CardDisputeNextAction["SUBMIT"] = "submit";
    CardDisputeNextAction["ADD_EVIDENCE"] = "add_evidence";
    CardDisputeNextAction["AWAIT_NETWORK_SUBMISSION"] = "await_network_submission";
    CardDisputeNextAction["AWAIT_NETWORK_RESPONSE"] = "await_network_response";
    CardDisputeNextAction["AWAIT_MANUAL_ARBITRATION"] = "await_manual_arbitration";
    CardDisputeNextAction["RESOLVE_REQUIRED_ACTION"] = "resolve_required_action";
    CardDisputeNextAction["RESPOND_TO_PREARBITRATION"] = "respond_to_prearbitration";
    CardDisputeNextAction["RESPOND_TO_MERCHANT_RESPONSE"] = "respond_to_merchant_response";
})(CardDisputeNextAction || (CardDisputeNextAction = {}));
export var CardDisputeStatus;
(function (CardDisputeStatus) {
    CardDisputeStatus["OPEN"] = "open";
    CardDisputeStatus["REQUIRES_ACTION"] = "requires_action";
    CardDisputeStatus["MANUAL_REVIEW_REQUIRED"] = "manual_review_required";
    CardDisputeStatus["CLOSED"] = "closed";
})(CardDisputeStatus || (CardDisputeStatus = {}));
export var CustomRoleGranularPermissionLevel;
(function (CustomRoleGranularPermissionLevel) {
    CustomRoleGranularPermissionLevel["DEFAULT"] = "default";
    CustomRoleGranularPermissionLevel["NONE"] = "none";
    CustomRoleGranularPermissionLevel["READ"] = "read";
    CustomRoleGranularPermissionLevel["UPDATE"] = "update";
    CustomRoleGranularPermissionLevel["WRITE"] = "write";
})(CustomRoleGranularPermissionLevel || (CustomRoleGranularPermissionLevel = {}));
export var CustomRolePermissionLevel;
(function (CustomRolePermissionLevel) {
    CustomRolePermissionLevel["DEFAULT"] = "default";
    CustomRolePermissionLevel["NONE"] = "none";
    CustomRolePermissionLevel["READ"] = "read";
    CustomRolePermissionLevel["WRITE"] = "write";
})(CustomRolePermissionLevel || (CustomRolePermissionLevel = {}));
/**
 * Dashboard display mode
 */
export var DashboardDisplayMode;
(function (DashboardDisplayMode) {
    DashboardDisplayMode["LIGHT"] = "light";
    DashboardDisplayMode["DARK"] = "dark";
})(DashboardDisplayMode || (DashboardDisplayMode = {}));
/**
 * Email verification state
 */
export var EmailState;
(function (EmailState) {
    EmailState["EMAILSTATE_NONE"] = "EMAILSTATE_NONE";
    EmailState["NOT_VERIFIED"] = "NOT_VERIFIED";
    EmailState["VERIFY_IN_PROGRESS"] = "VERIFY_IN_PROGRESS";
    EmailState["VERIFIED"] = "VERIFIED";
})(EmailState || (EmailState = {}));
/**
 * Login challenge name
 */
export var LoginChallengeName;
(function (LoginChallengeName) {
    LoginChallengeName["CHALLENGE_NONE"] = "CHALLENGE_NONE";
    LoginChallengeName["CHALLENGE_MFA_SMS"] = "CHALLENGE_MFA_SMS";
    LoginChallengeName["CHALLENGE_MFA_TOTP"] = "CHALLENGE_MFA_TOTP";
})(LoginChallengeName || (LoginChallengeName = {}));
/**
 * Email confirmation status
 */
export var LoginEmailConfirmationStatus;
(function (LoginEmailConfirmationStatus) {
    LoginEmailConfirmationStatus["NONE"] = "NONE";
    LoginEmailConfirmationStatus["UNVERIFIED"] = "UNVERIFIED";
    LoginEmailConfirmationStatus["VERIFIED"] = "VERIFIED";
    LoginEmailConfirmationStatus["NOT_REQUIRED"] = "NOT_REQUIRED";
})(LoginEmailConfirmationStatus || (LoginEmailConfirmationStatus = {}));
/**
 * MFA status
 */
export var LoginMfaStatus;
(function (LoginMfaStatus) {
    LoginMfaStatus["NONE"] = "NONE";
    LoginMfaStatus["UNVERIFIED"] = "UNVERIFIED";
    LoginMfaStatus["VERIFIED"] = "VERIFIED";
    LoginMfaStatus["NOT_REQUIRED"] = "NOT_REQUIRED";
    LoginMfaStatus["VERIFIED_LEGACY"] = "VERIFIED_LEGACY";
})(LoginMfaStatus || (LoginMfaStatus = {}));
/**
 * Groups of related notifications.
 */
export var NotificationCategory;
(function (NotificationCategory) {
    NotificationCategory["TRANSFER_OUTGOING_PENDING_APPROVAL"] = "transfer.outgoing.pending_approval";
    NotificationCategory["TRANSFER_OUTGOING_INITIATED"] = "transfer.outgoing.initiated";
    NotificationCategory["TRANSFER_OUTGOING_COMPLETED"] = "transfer.outgoing.completed";
    NotificationCategory["TRANSFER_OUTGOING_RETURNED"] = "transfer.outgoing.returned";
    NotificationCategory["TRANSFER_INCOMING_RECEIVED"] = "transfer.incoming.received";
    NotificationCategory["TRANSFER_INCOMING_PENDING_RETURN"] = "transfer.incoming.pending_return";
    NotificationCategory["TRANSFER_INCOMING_RETURNED"] = "transfer.incoming.returned";
})(NotificationCategory || (NotificationCategory = {}));
/**
 * Delivery channel for a notification.
 */
export var NotificationType;
(function (NotificationType) {
    NotificationType["EMAIL"] = "email";
})(NotificationType || (NotificationType = {}));
export var WireReturnRequestReason;
(function (WireReturnRequestReason) {
    WireReturnRequestReason["INCORRECT_BENEFICIARY_ACCOUNT"] = "incorrect_beneficiary_account";
    WireReturnRequestReason["INCORRECT_AMOUNT"] = "incorrect_amount";
    WireReturnRequestReason["REQUESTED_BY_ORIGINATOR"] = "requested_by_originator";
    WireReturnRequestReason["DUPLICATE"] = "duplicate";
    WireReturnRequestReason["FRAUD"] = "fraud";
    WireReturnRequestReason["TECH_FAILURE"] = "tech_failure";
    WireReturnRequestReason["PAYMENT_NOT_JUSTIFIED"] = "payment_not_justified";
})(WireReturnRequestReason || (WireReturnRequestReason = {}));
export var WireReturnRequestRejectReason;
(function (WireReturnRequestRejectReason) {
    WireReturnRequestRejectReason["BENEFICIARY_ACCOUNT_CLOSED"] = "beneficiary_account_closed";
    WireReturnRequestRejectReason["NON_SUFFICIENT_FUNDS"] = "non_sufficient_funds";
    WireReturnRequestRejectReason["FUNDS_ALREADY_RETURNED"] = "funds_already_returned";
    WireReturnRequestRejectReason["REJECTED_BY_BENEFICIARY"] = "rejected_by_beneficiary";
    WireReturnRequestRejectReason["LEGAL_DECISION"] = "legal_decision";
    WireReturnRequestRejectReason["NO_RESPONSE_FROM_BENEFICIARY"] = "no_response_from_beneficiary";
})(WireReturnRequestRejectReason || (WireReturnRequestRejectReason = {}));
//# sourceMappingURL=types.gen.js.map